import React, { useState } from 'react';
import { ArrowRight } from 'lucide-react';

interface JoinSchoolFormProps {
  onJoin: (code: string) => Promise<void>;
  loading: boolean;
}

export default function JoinSchoolForm({ onJoin, loading }: JoinSchoolFormProps) {
  const [schoolCode, setSchoolCode] = useState('');

  const handleSubmit = async () => {
    if (!schoolCode.trim()) return;
    await onJoin(schoolCode);
  };

  return (
    <div className="mb-6">
      <div className="flex gap-2">
        <input
          type="text"
          value={schoolCode}
          onChange={(e) => setSchoolCode(e.target.value)}
          placeholder="Enter school code"
          className="flex-1 px-4 py-2 rounded-lg border border-border-light focus:border-primary-500 
                   focus:ring-2 focus:ring-primary-500/20 outline-none transition-all"
        />
        <button
          onClick={handleSubmit}
          disabled={loading}
          className="px-4 py-2 bg-primary-500 text-white rounded-lg hover:bg-primary-600 
                   transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
        >
          Join
          <ArrowRight className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}